import { useCallback, useSyncExternalStore } from "react";
import { type MessageDraftKey, messageDraftStore } from "./messageDraftStore";

export const useMessageDraft = (key: MessageDraftKey) => {
	const draft = useSyncExternalStore(messageDraftStore.subscribe, () => messageDraftStore.get(key));
	const setDraft = useCallback((html: string) => messageDraftStore.set(key, html), [key]);
	return [draft, setDraft] as const;
};

export const useHasMessageDraft = (key: MessageDraftKey) =>
	useSyncExternalStore(messageDraftStore.subscribe, () => messageDraftStore.get(key) !== "");
